import React, {FC} from 'react';

export interface IStandardWrapper {
    children: React.ReactNode
}

const StandardWrapper: FC<IStandardWrapper> = ({children}) => {
	return (
		<div className='container-fluid no-gutters'>
			{children}
		</div>
	);
};

export default StandardWrapper;
